<template>
  <div class="advertising-local-tree">
    <virtual-tree :nodes="flatNodes"
                  :node-index="flatIndex"
                  :selection="selection"
                  :loading="isLoading"
                  :item-height="40"
                  :max-visible-rows="8"
                  :indent-size="20"
                  :search-placeholder="$t('message.generics.message.search')"
                  :empty-message="emptyMessage"
                  @toggle-select="onToggleSelect">
      <template slot="row"
                slot-scope="{ row }">
        <advertising-local-tree-item :row="row" />
      </template>
    </virtual-tree>
  </div>
</template>

<script>
import VirtualTree from "@components/generic/virtual/tree/VirtualTree";
import { buildSelectionState, indexFlatTree } from "@packages/util/tree/flat-tree";
import { localTreeToFlat } from "@packages/util/tree/local-tree";
import AdvertisingLocalTreeItem from "./AdvertisingLocalTreeItem";

export default {
  components: {
    VirtualTree,
    AdvertisingLocalTreeItem,
  },

  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    loaded: {
      type: Boolean,
      default: false,
    },
    loadError: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isLoading() {
      return !this.loaded && !this.loadError && !this.list.length;
    },

    emptyMessage() {
      return this.loadError
        ? this.$t("message.errorMessages.message.loadLocalsError")
        : undefined;
    },

    flatNodes() {
      return localTreeToFlat(this.list);
    },

    flatIndex() {
      return indexFlatTree(this.flatNodes);
    },

    selection() {
      return buildSelectionState(this.flatIndex, (node) => node.selected);
    },
  },

  methods: {
    onToggleSelect({ node }) {
      this.$emit("toggle-node", node.raw);
    },
  },
};
</script>

<style lang="scss" scoped>
.advertising-local-tree {
  width: 100%;
}
</style>
